module.exports = __webpack_public_path__ + "media/images/vp/icon.tg.red-2c0c6740872e16c4eec650cff73f892c.png";